import { render, staticRenderFns } from "./AdminStudyGroupForm.vue?vue&type=template&id=4dd68fa6&"
import script from "./AdminStudyGroupForm.vue?vue&type=script&lang=js&"
export * from "./AdminStudyGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports